import { Paper, styled } from '@mui/material';

export const StyledDayColumnWrap = styled('div')({
	display: 'flex',
	gap: '8px',
	flexDirection: 'column',
});

export const StyledDayColumnHeaderCell = styled(Paper)(({ theme }) => ({
	borderRadius: '10px',
	padding: '8px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '8px',

	[theme.breakpoints.down('sm')]: {
		display: 'none',
	},
}));

export const StyledDayColumnHeaderEmoji = styled('img')({
	width: '16px',
	height: '16px',
});

export const StyledHourSlotWrap = styled(Paper)({
	borderRadius: '16px',
	padding: '8px',
	minHeight: '110px',
});
